import { render, staticRenderFns } from "./user-file-header.vue?vue&type=template&id=d1780d46&"
import script from "./user-file-header.vue?vue&type=script&lang=js&"
export * from "./user-file-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports